<template>
    <div class='page-view view view--page'>
        <div class='view__content' data-scroll-section>
            <transition name='vue-fade'>
                <Spinner v-if='!page' :variants='["large", "fixed"]' />

                <PageTier v-else :page='page' />
            </transition>
        </div>
        <div data-scroll-section>
            <transition name='vue-fade-delay'>
                <Footer v-if='page' id='footer' data-scroll-id='footer' data-scroll />
            </transition>
        </div>
    </div>
</template>

<script>
import Spinner from '^/components/elements/Spinner.vue'
import PageTier from '^/components/tiers/PageTier.vue'
import Footer from '^/components/Footer.vue'

export default {
    name: 'PageView',
    props: {
        slug: {
            type: String,
            required: true
        }
    },
    data: () => ({
        page: null
    }),
    created () {
        fetch(`/pages/${this.slug}?view=json`).then(response => {
            return response.json()
        }).then(data => {
            this.page = data.page
        })
    },
    components: {
        Spinner,
        PageTier,
        Footer
    }
}
</script>

